import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {BranchesService} from './branches.service';
import {Branch} from '../master-data/master-data.model';

@Injectable({
  providedIn: 'root'
})
export class BranchesResolver  {
  private branchesService = inject(BranchesService);


  getBranches() {
    return this.branchesService.getAllBranches();
  }

}
export const branchesResolver: ResolveFn<Branch[]> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(BranchesResolver).getBranches();
  };
